import HttpRequest from '@/plugins/axios'

class GenericProvider extends HttpRequest {
  constructor() {
    super(process.env.VUE_APP_CENTRAL_API_URL)
  }

  async getRegistrarFaculty() {
    const { data } = await this.get('faculty/', {
      function: 'get-registrar-faculty',
    })
    return data
  }

  async getAllRegistrarDepartment() {
    const { data } = await this.get('department/', {
      function: 'get-registrar-department',
    })
    return data
  }

  async getRegistrarCurriculum(level_id, faculty_id, curriculum_id, department_id) {
    const { data } = await this.get('curriculum/', {
      function: 'get-registrar-curriculum',
      level_id,
      faculty_id,
      curriculum_id,
      department_id,
    })
    return data
  }

  async getRegistrarCurriculumByObject({level_id, faculty_id, curriculum_id, department_id}) {
    const { data } = await this.get('curriculum/', {
      function: 'get-registrar-curriculum',
      level_id,
      faculty_id,
      curriculum_id,
      department_id,
    })
    return data
  }

  async getAllRegistrarBachelorCurriculum() {
    const { data } = await this.get('curriculum/', {
      function: 'get-registrar-curriculum',
      level_id: '1',
    })
    return data
  }

  async getRegistrarSubject(level_id, subject_id) {
    const { data } = await this.get('subject/', {
      function: 'get-registrar-subject',
      level_id,
      subject_id,
    })
    return data
  }

  async getRegistrarBuilding() {
    const { data } = await this.get('building/', {
      function: 'get-registrar-building',
    })
    return data
  }

  async getRegistrarRoom(building_no) {
    const { data } = await this.get('building/', {
      function: 'get-registrar-room',
      building_no,
    })
    return data
  }

  async getStudentData(student_id) {
    const { data } = await this.get('student/', {
      function: 'get-student-data',
      student_id,
    })
    return data
  }

}

export default GenericProvider